import { render } from "./StaffPromotion.vue?vue&type=template&id=1f08f5da&scoped=true"
import script from "./StaffPromotion.vue?vue&type=script&lang=js"
export * from "./StaffPromotion.vue?vue&type=script&lang=js"

import exportComponent from "D:\\_2021\\项目管理系统\\TYH_office_automation\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f08f5da"]])

export default __exports__